import AssetLibrary from "./AssetLibrary";

const assetLibrary = new AssetLibrary();

assetLibrary.loadAssets();

export default assetLibrary;
